function OptionButton({ name, onClick, tooltip, link, isHighlighted }) {
    return (
        <div className="tooltip-container">
            <button className="option-button" onClick={onClick}>
                <img src={`/${name}.webp`} alt={name} className={isHighlighted ? "option-icon-highlight" : "option-icon"} />
            </button>
            <span className="tooltip-text">{tooltip}</span>
        </div>
    );
}

export default OptionButton;
